import Watcher from './watcher.js'

const watcher = Watcher();

const links = {
    selector: 'a',
    event: 'click',
    watch: function() {
        let URL = '';
        let href = $(this).attr("href");

        if (!href) URL = watcher.pathname + $(this).attr("data-bs-target").slice(1)  //speaker
        else if (href.slice(0,1) == "#") URL = watcher.pathname + href.slice(1); //exhibitor stand button
        else if ($(this).attr("id") == "social-media-button-twitter") URL = href; //social media link
        else URL = watcher.getPath(href); //all other links
    
        watcher.payload.URL = URL;
        watcher.emit('click', watcher.payload);
    }
}

const networkinMail = {
    selector: '#send-mail-btn',
    event: 'click',
    watch: function() {
        watcher.payload.URL = 'networking-send-mail';
        watcher.emit('click', watcher.payload);
    }
}

const hotspots = {
    selector: 'path',
    event: 'click',
    waitFor: '.hotspot-default',
    watch: function(event) {
        if (event.target.ariaLabel === null) return;

        watcher.payload.URL = watcher.pathname + event.target.ariaLabel;
        watcher.emit('click', watcher.payload);
    }
}

const targetBlank = {
    selector: 'a[target="_blank"]',
    event: 'click',
    watch: function() {
        watcher.payload.URL = $(this).attr("href");
        watcher.emit('click', watcher.payload);
    }
}

const inputSession = {
    selector: '#inputSessionHidden',
    event: 'click',
    watch: function() {
        let URL = $(this).attr("value");
        watcher.payload.URL = URL;
        watcher.emit('click', watcher.payload);
    }
}

watcher.watch([
    links,
    networkinMail,
    targetBlank,
    hotspots,
    inputSession
]);
